<div class="cg-button-group">
  <button
    *ngIf="showPrevious"
    data-test="prev-btn"
    [disabled]="submitting"
    (click)="previous.emit()"
    cignaButton="secondary"
  >
    {{ previousButtonLabel }}
  </button>
  <button
    data-test="next-btn"
    [disabled]="
      !nextEnabled || submitting || (shouldShowInvalidEmailMsg && !isEmailValid)
    "
    (click)="next.emit()"
    cignaButton="primary"
  >
    {{ nextButtonLabel }}
  </button>
  <button
    *ngIf="showCancel"
    data-test="cancel-link"
    (click)="cancel()"
    cignaButton="link"
  >
    Cancel
  </button>
  <div
    *ngIf="submitting"
    style="display: inline-block; vertical-align: bottom"
    class="cg-spinner cg-margin-left-md"
  ></div>

  <div
    *ngIf="shouldShowInvalidEmailMsg && !isEmailValid && !isEmailValidErrorMsg"
    class="cg-error-msg"
  >
    <cigna-icon type="exclamation-circle"></cigna-icon>

    <span data-test="denied-email-err" *ngIf="appContext === 'chcp'">
      There is an issue with the email address. If you still need to provide
      access to this user, please contact Customer Service at 1.800.981.9114.
    </span>

    <span data-test="denied-email-err" *ngIf="appContext === 'evernorth'">
      There is an issue with the email address. If you still need to provide
      access to this user, please contact Customer Service at
      1.888.736.7499.</span
    >
  </div>

  <div *ngIf="isEmailValidErrorMsg" class="cg-error-msg">
    <cigna-icon type="exclamation-circle"></cigna-icon>
    {{ isEmailValidErrorMsg }}
  </div>
</div>
